import { Link, useSearchParams } from "react-router-dom";
import { ChatThread } from "@/components/ChatThread";
import { ScreenTitle } from "@/components/ui/Section";

export function ChatView() {
  const [params] = useSearchParams();
  // Spec 020 D5/D7: the «Обсуждения» tab. It opens on the newest message, or on
  // the one a link points at (`?message=`, «Полностью» from Telegram).
  return <div className="flex flex-col gap-4 pt-2">
    <ScreenTitle
      eyebrow="Общий чат"
      trailing={<Link className="text-meta text-p-link" to="/settings/notifications">Уведомления</Link>}
    >
      Обсуждения
    </ScreenTitle>
    <p className="text-meta text-p-text-muted">Переписка, файлы и обсуждения задач и идей. Ответ сохраняется в обсуждении исходного сообщения.</p>
    <ChatThread focusId={params.get("message") ?? undefined} pinToLatest />
  </div>;
}
